var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3H15L12.5 0.5H7.49937L5 3H2.5C2.5 3 0 3 0 5.5C0 6.83563 0 11.3813 0 13C0 15.5 2.5 15.5 2.5 15.5C2.5 15.5 15.8006 15.5 17.5 15.5C20 15.5 20 13 20 13C20 13 20 8 20 5.5C20 3 17.5 3 17.5 3ZM10 13C7.9275 13 6.25 11.3225 6.25 9.25C6.25 7.18 7.9275 5.5 10 5.5C12.0694 5.5 13.75 7.18 13.75 9.25C13.75 11.3225 12.0694 13 10 13Z",
    fill: "#CFD6E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5eb468a62b4de43f7faf517b1b9e02ab.svg";
export { ForwardRef as ReactComponent };